module.exports = __webpack_public_path__ + "static/2@2x-665fdb843659b87e67a2f02e9b7d41d7.png";